import React from "react";
import { Modal } from "antd";
import "./CustomPopup.scss";
import { CloseOutlined } from "@ant-design/icons";
import iconVoPhao from "../../../../assets/images/event-2024/popup/icon-vo-phao.png";
import iconDiem from "../../../../assets/images/event-2024/popup/icon-diem.png";
import bgPopupTest from "../../../../assets/images/event-2024/popup/pop-up-0.png";
import btnActionBg from "../../../../assets/images/event-2024/popup/btn-event-popup.png";

export default function PopupComponents({
  title = "",
  open,
  setOpen = () => {},
  backgroundPopup = "",
  btnAction = {
    action: () => {},
    title: "",
  },
  isHiddenBtnAction = false,
  btnAction2 = false,
  isBottom = false,
  description = "",
  dataType = ""
}) {
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Modal
      centered
      visible={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      className="custom-popup-event-2024"
      footer={false}
      closable={false}
    >
      <div className="gift-container-lm">
        <img
          src={backgroundPopup || bgPopupTest}
          alt=""
          className="bg-image-gift-event"
        />
        <div className="btn-close-popup-event" onClick={handleCancel}>
          <CloseOutlined />
        </div>
        <div
          className="container-event-popup-content-2024"
          style={{ bottom: `${isHiddenBtnAction || isBottom ? "30px" : ""}` }}
        >
          <div
            className={`main-content-event ${dataType == 'GOOD_LUCK' ? 'content-good-luck' : ''}`}
            dangerouslySetInnerHTML={{ __html: title }}
          ></div>
          <div className="btn-action-popup">
            {!isHiddenBtnAction ? (
              <div className="position-relative container-btn-action">
                <div
                  className="position-relative container-btn-action-main"
                  onClick={btnAction.action}
                >
                  <img
                    src={btnActionBg}
                    alt=""
                    className="icon-bg-action-2024"
                  />
                  <div
                    className={`content-btn-action ${
                      btnAction2 ? "content-btn-action-2" : ""
                    } ${btnAction?.class ? btnAction?.class : ""}`}
                  >
                    {btnAction2 ? <img src={iconDiem} /> : null}
                    {btnAction.title || "¡Únete ahora!"}
                  </div>
                </div>
              </div>
            ) : null}

            {btnAction2 ? (
              <div
                className="position-relative container-btn-action"
                style={{ marginTop: "5px" }}
              >
                <div
                  className="container-btn-action-main position-relative"
                  onClick={btnAction2.action}
                >
                  <img
                    src={btnActionBg}
                    alt=""
                    className="icon-bg-action-2024"
                  />
                  <div
                    className={`content-btn-action ${
                      btnAction2 ? "content-btn-action-2 fz-16px" : ""
                    }`}
                  >
                    {btnAction2.title}
                    <img src={iconVoPhao} />
                  </div>
                </div>
              </div>
            ) : null}

            <div
              className="action-des-event"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
